module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_7.6793edbe.svg";